var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelectedPersons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_445_15084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 12C16 12.7911 15.7654 13.5645 15.3259 14.2223C14.8864 14.8801 14.2616 15.3928 13.5307 15.6955C12.7998 15.9983 11.9956 16.0775 11.2196 15.9231C10.4437 15.7688 9.73098 15.3878 9.17157 14.8284C8.61216 14.269 8.2312 13.5563 8.07686 12.7804C7.92252 12.0044 8.00173 11.2002 8.30448 10.4693C8.60723 9.73836 9.11992 9.11365 9.77772 8.67412C10.4355 8.2346 11.2089 8 12 8",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.99951L12.3533 12.6462C12.307 12.6926 12.2519 12.7295 12.1913 12.7546C12.1306 12.7797 12.0656 12.7927 12 12.7927C11.9344 12.7927 11.8694 12.7797 11.8087 12.7546C11.7481 12.7295 11.693 12.6926 11.6467 12.6462L10.5 11.5002",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.688 7.50879C6.94598 6.85437 5.98937 6.4954 5 6.50012C4.02034 6.49244 3.07192 6.84456 2.33462 7.48969C1.59733 8.13483 1.12243 9.02811 1 10.0001",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 3.25C2.75 3.84674 2.98705 4.41903 3.40901 4.84099C3.83097 5.26295 4.40326 5.5 5 5.5C5.59674 5.5 6.16903 5.26295 6.59099 4.84099C7.01295 4.41903 7.25 3.84674 7.25 3.25C7.25 2.65326 7.01295 2.08097 6.59099 1.65901C6.16903 1.23705 5.59674 1 5 1C4.40326 1 3.83097 1.23705 3.40901 1.65901C2.98705 2.08097 2.75 2.65326 2.75 3.25V3.25Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 2.75C9.75 3.21413 9.93437 3.65925 10.2626 3.98744C10.5908 4.31563 11.0359 4.5 11.5 4.5C11.9641 4.5 12.4092 4.31563 12.7374 3.98744C13.0656 3.65925 13.25 3.21413 13.25 2.75C13.25 2.28587 13.0656 1.84075 12.7374 1.51256C12.4092 1.18437 11.9641 1 11.5 1C11.0359 1 10.5908 1.18437 10.2626 1.51256C9.93437 1.84075 9.75 2.28587 9.75 2.75V2.75Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1001 6.49977C13.8614 6.08663 13.5276 5.73638 13.1265 5.47809C12.7253 5.2198 12.2683 5.06092 11.7934 5.01464C11.3185 4.96835 10.8395 5.03601 10.396 5.21198C9.95249 5.38795 9.55737 5.66716 9.24341 6.02643",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_445_15084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedPersons);
export default __webpack_public_path__ + "static/media/SelectedPersons.14ea10a604e30f1d626ec97852283f02.svg";
export { ForwardRef as ReactComponent };